module.exports = __webpack_public_path__ + "img/signal_cellular_1_bar-green.938b759a.svg";